import React, { useState, useRef, useEffect } from 'react';
import { StatefulSearch } from 'components/schedules/StatefulSearch';
import { injectIntl } from 'react-intl';
import { Button, Modal, Input, Form } from 'semantic-ui-react';
import 'react-dates/lib/css/_datepicker.css';
import 'react-dates/initialize';
import { SingleDatePicker } from 'react-dates';
import { breakpoints } from 'helpers/breakpoints';
import _ from 'lodash';
import moment from 'moment-timezone';
import styled from 'styled-components';
import { useOutsideClick } from 'hooks/use-outside-click';
import { colors, mediaQueries } from '../../../styles/variables';
import styles from './TimeslotModal.css';
import { locale } from './locale';
import CrossIcon from '../../../assets/add-ons/cross.svg';

const StyledWrapperStart = styled.div`
  width: 50%;

  .SingleDatePicker.DateInput__block {
    flex: 1 0 auto;
  }

  .SingleDatePicker .DateInput__block {
    flex: 1 0 auto;
  }

  .SingleDatePicker .SingleDatePickerInput_calendarIcon {
    position: absolute;
    padding-left: 0;
    padding-right: 0;
    z-index: 1;
    line-height: 26px;
    @media (${mediaQueries.breakBeforeSm}) {
      line-height: 16px;
    }
    @media (${mediaQueries.breakAfterSm}) {
      line-height: 16px;
    }
  }

  .SingleDatePicker input {
    flex: 1 0 auto !important;
    max-height: 36px;
    font-family: Graphik, Helvetica, helvetica, arial, sans-serif;
  }

  .CalendarDay__selected {
    background: ${colors.blue};
  }

  .CalendarDay__selected:hover {
    background: ${colors.blue};
  }

  .DateInput_input {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    height: 44px;
    font-size: 14px !important;
    @media (${mediaQueries.breakBeforeSm}) {
      font-size: 1em !important;
      height: 36px;
    }
    border-color: ${props => props.isInvalidStartDate ? `var(--color-red-darker) !important` : ``};
    background-color: ${props => props.isInvalidStartDate ? `var(--color-coral-lighter) !important` : ``};
    padding: 8px !important;
  }

  .DateInput_input__focused {
    border-color: ${props => props.isInvalidStartDate ? `var(--color-red-darker) !important` : `${colors.blue} !important`};
  }

  .DateInput_input__disabled {
    font-style: inherit;
  }

  .DateInput__disabled {
    background: ${colors.space};
    color: ${colors.inkLight};
  }

  .DayPicker_weekHeader {
    top: 55px !important;
  }

  .DayPicker_transitionContainer {
    padding-bottom: 24px !important
  }

  .DayPickerNavigation_button {
    box-shadow: none;

    & svg path {
      fill: var(--color-ink-light);
    }
  }

  .DateInput_fang {
    z-index: -1;
  }

  .SingleDatePicker_picker {
    top: 55px !important;
    border-radius: 6px !important;
  }

`;

const StyledWrapperEnd = styled.div`
  width: 50%;

  .SingleDatePicker.DateInput__block {
    flex: 1 0 auto;
  }

  .SingleDatePicker .DateInput__block {
    flex: 1 0 auto;
  }

  .SingleDatePicker .SingleDatePickerInput_calendarIcon {
    position: absolute;
    padding-left: 0;
    padding-right: 0;
    z-index: 1;
    line-height: 26px;
    @media (${mediaQueries.breakBeforeSm}) {
      line-height: 16px;
    }
    @media (${mediaQueries.breakAfterSm}) {
      line-height: 16px;
    }
  }

  .SingleDatePicker input {
    flex: 1 0 auto !important;
    max-height: 36px;
    font-family: Graphik, Helvetica, helvetica, arial, sans-serif;
    border: 1px solid ${colors.orbit};
    border-top-right-radius: 6px !important;
    border-bottom-right-radius: 6px !important;
    border-left: none;
  }

  .DayPicker__withBorder {
    box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.05), 0 0 0 1px ${colors.orbit};
  }

  .CalendarDay__selected {
    background: ${colors.blue};
  }

  .CalendarDay__selected:hover {
    background: ${colors.blue};
  }

  .DateInput_input {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    border-left-color: transparent !important;
    height: 44px;
    font-size: 14px !important;
    @media (${mediaQueries.breakBeforeSm}) {
      font-size: 1em !important;
      height: 36px;
    }
    border-color: ${props => props.isInvalidEndDate ? `var(--color-red-darker) !important` : ``};
    background-color: ${props => props.isInvalidEndDate ? `var(--color-coral-lighter) !important` : ``};
    border-left-color: ${props => props.isInvalidStartDate ? `transparent !important` : ``};
    padding: 8px !important;
  }

  .DateInput_input__focused {
    border-color: ${props => props.isInvalidEndDate ? `var(--color-red-darker) !important` : `${colors.blue} !important`};
    border-left-color: ${props => props.isInvalidStartDate ? `transparent !important` : ``};
  }

  .DateInput_input__disabled {
    font-style: inherit;
  }

  .DateInput__disabled {
    background: ${colors.space};
    color: ${colors.inkLight};
  }

  .DayPicker_weekHeader {
    top: 55px !important;
  }

  .DayPicker_transitionContainer {
    padding-bottom: 16px !important
  }

  .DayPickerNavigation_button {
    box-shadow: none;

    & svg path {
      fill: var(--color-ink-light);
    }
  }

  .DateInput_fang {
    z-index: -1;
  }

  .SingleDatePicker_picker {
    top: 55px !important
  }
`;

export const TimeslotModal = injectIntl((
  { intl, isOpen, setShowTimeslotModal, selectedWeekDays, handleTimeslotsSelected,
      setSelectedWeekDays, startTime, setStartTime, endTime, setEndTime,
      startDate, setStartDate, endDate, setEndDate, weekDays, slots, ongoingEnable, setOngoingEnable,
      isActive, setIsActive, firstEventDate, exclusiveWeekday
  }) => {
  const [isInvalidStartTime, setIsInvalidStartTime] = useState(false);
  const [isInvalidEndTime, setIsInvalidEndTime] = useState(false);
  const [focusedStart, setFocusedStart] = useState(false);
  const [focusedEnd, setFocusedEnd] = useState(false);
  const [datesWithTimeslots, setDatesWithTimeslots] = useState([]);
  const [isInvalidStartDate, setIsInvalidStartDate] = useState(false);
  const [isInvalidEndDate, setIsInvalidEndDate] = useState(false);
  const [isInvalidWeekday, setIsInvalidWeekday] = useState(false);
  const [startDateArray, setStartDateArray] = useState([]);
  const searchRef = useRef();
  const outsideClickRef = useRef();

  useEffect(() => {
    if (!isOpen) {
      setIsInvalidStartTime(false);
      setIsInvalidEndTime(false);
    }
  }, [isOpen]);

  useEffect(() => {
    if (startTime && !endTime) {
      searchRef.current.focus();
    } else if (!startTime && endTime && !document.getElementById('endTimeId').matches(':focus')) {
      setIsInvalidStartTime(true);
    }
  }, [startTime, endTime]);

  useEffect(() => {
    if (isInvalidStartDate || isInvalidEndDate || isInvalidStartTime || isInvalidEndTime
      || (!startDate && !endDate) || (startTime && !endTime) || (endTime && !startTime)
      || (startDate && ((endDate === null || endDate === undefined) && !ongoingEnable))
      || (isInvalidWeekday)
    ) {
      setIsActive(true);
    } else {
      setIsActive(false);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInvalidStartDate, isInvalidEndDate, startDate,
  endDate, ongoingEnable, startTime, endTime, isInvalidStartTime, isInvalidEndTime, isInvalidWeekday]);

  useEffect(() => {
    setDatesWithTimeslots(slots);
  }, [slots]);

  useEffect(() => {
    if (selectedWeekDays.length > 0 && endDate && startDate) {
      if (exclusiveWeekday.length > 0) {
        const valueNotExist = selectedWeekDays.some(r=> !exclusiveWeekday.includes(r));
        if (valueNotExist) {
          setIsInvalidWeekday(true);
        } else {
          setIsInvalidWeekday(false);
        }
      }
    } else {
      setIsInvalidWeekday(false);
    }
  }, [selectedWeekDays, startDate, endDate, exclusiveWeekday]);

  useEffect(() => {
    if (!focusedStart && !focusedEnd && startDate && !endDate && !ongoingEnable) {
      setIsInvalidEndDate(true);
    } else if (startDate && endDate) {
      setIsInvalidEndDate(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [focusedStart, focusedEnd])

  useEffect(() => {
    datesWithTimeslots.forEach((dateTime)=> {
      // if start date/end date is not equal,
      // get all timeslots which comes inBetween which is greater/equal from current date.
      const startInterval = dateTime.startAt.substr(0,10);
      const endInterval = dateTime.endAt.substr(0,10);
      const formattedStartOfDay = moment().startOf('day').format('YYYY-MM-DD');
      const isStartDateExist = new Set(startDateArray).has(startInterval);
      if (startInterval !== endInterval) {
        for (const interval = moment(startInterval); interval.isSameOrBefore(endInterval); interval.add(1, 'days')) {
          const formattedInterval = interval.format('YYYY-MM-DD');
          const isDateExist = new Set(startDateArray).has(formattedInterval);
          if ((formattedInterval >= formattedStartOfDay)
            && !isDateExist
          ) {
            startDateArray.push(formattedInterval);
          }
        }
      } else if ((startInterval >= formattedStartOfDay)
          && !isStartDateExist
        ) {
          startDateArray.push(startInterval);
      }
    });
    setStartDateArray(startDateArray);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [datesWithTimeslots]);

  const handleClickOutside = () => {
    if (!endTime && startTime && !document.getElementById('endTimeId').matches(':focus')) {
      setIsInvalidEndTime(true);
    }
    if (ongoingEnable) {
      setIsInvalidEndDate(false);
    }
    setFocusedStart(false);
    setFocusedEnd(false);
  };

  useOutsideClick(outsideClickRef, handleClickOutside);

  const onStartDateChange = (value) => {
    setStartDate(value);
    if (!endDate && !ongoingEnable) {
      setFocusedEnd(true);
      setIsInvalidEndDate(true);
    }

    if (endDate && moment(value.format('YYYY-MM-DD')).isAfter(endDate.format('YYYY-MM-DD'))) {
      setIsInvalidStartDate(true);
      setIsInvalidEndDate(true);
    } else {
      setIsInvalidStartDate(false);
      setIsInvalidEndDate(false);
    }
  }

  const onEndDateChange = (value) => {
    setEndDate(value);
    if (!startDate) {
      setIsInvalidStartDate(true);
    }

    if (startDate && value.diff(startDate) < 0) {
      setIsInvalidEndDate(true);
    }

    if (startDate && endDate && value.diff(startDate) >= 0) {
      setIsInvalidEndDate(false);
      setIsInvalidStartDate(false);
    }
  }

  const handleOngoingButton = () => {
    setEndDate(null);
    setOngoingEnable(true);
    setFocusedEnd(false);
    setIsInvalidEndDate(false);
    if (!startDate) {
      setIsInvalidStartDate(true);
    } else {
      setIsInvalidStartDate(false);
    }
  }

  function isEndDateOutsideRange(day) {
    const isRange = startDateArray.includes(day.format('YYYY-MM-DD'));
    if (startDate) {
      return (day.startOf('day') < startDate.startOf('day')) || !isRange;
    }
    return !isRange;
  }

  const isStartDateOutsideRange = (day) => {
    return !startDateArray.includes(day.format('YYYY-MM-DD'));
  }

  const initialVisibleMonthStart = () => {
    if (startDate) {
      return moment(startDate);
    }
    return moment() < moment(firstEventDate?.startAt)
    ? moment(firstEventDate?.startAt)
    : moment();
  }

  const initialVisibleMonthEnd = () => {
    if (endDate) {
      return moment(endDate);
    }

    if (startDate) {
      return moment(startDate);
    }

    return moment() < moment(firstEventDate?.endAt)
      ? moment(firstEventDate?.endAt)
      : moment();
  }

  const renderDateRange = () => {
    const customPosition = window.innerWidth < breakpoints.tablet ? 'right' : 'left';
    return <div className={styles.DateRangeCalender} ref={outsideClickRef}>
      <StyledWrapperStart isInvalidStartDate={isInvalidStartDate}>
        <SingleDatePicker
          id="start-date"
          className={styles.DatePickerStyle}
          disabled={false}
          readOnly
          placeholder={intl.formatMessage(locale.startDate)}
          displayFormat="MMM D, YYYY"
          numberOfMonths={1}
          noBorder
          block
          openDirection='down'
          onFocusChange={({ focused }) => {
            setFocusedStart(focused);
          }}
          onDateChange={value => onStartDateChange(value)}
          date={startDate}
          initialVisibleMonth={() => initialVisibleMonthStart()}
          focused={focusedStart}
          hideKeyboardShortcutsPanel
          isOutsideRange={day => isStartDateOutsideRange(day)}
        />           
      </StyledWrapperStart>
      <StyledWrapperEnd isInvalidEndDate={isInvalidEndDate} isInvalidStartDate={isInvalidStartDate}>
        <SingleDatePicker
          id="end-date"
          readOnly
          noBorder
          placeholder={!ongoingEnable ? intl.formatMessage(locale.endDate) : ''}
          displayFormat="MMM D, YYYY"
          numberOfMonths={1}
          block
          openDirection='down'
          onFocusChange={({ focused }) => {
            setFocusedEnd(focused);
          }}
          onDateChange={value => onEndDateChange(value)}
          initialVisibleMonth={() => initialVisibleMonthEnd()}
          date={endDate}
          focused={focusedEnd}
          hideKeyboardShortcutsPanel
          calendarInfoPosition="bottom"
          anchorDirection={customPosition}
          renderCalendarInfo={() => <Button className={styles.onGoingButton} onClick={() => handleOngoingButton()}>
              {intl.formatMessage(locale.ongoingButton)}
            </Button>}
          customInputIcon={(ongoingEnable && endDate === null)
            ? <div className={styles.customIconPosition}>Ongoing</div>
            : <></>}
          isOutsideRange={day => isEndDateOutsideRange(day)}
        />     
      </StyledWrapperEnd>
    </div>
  }

  const selectWeekday = (day) => {
    const selectedDays = [...selectedWeekDays];
    if (_.includes(selectedDays, day)) _.remove(selectedDays, (n) => day === n);
    else selectedDays.push(day);
    setSelectedWeekDays(selectedDays);
  }

  const getWeekDaySelectorClass = (index) => _.includes(selectedWeekDays, index) ? styles.weekDaySelected : '';

  const renderWeekDaySelector = () => {
    return (
      <div className={styles.weekDaySelector}>
        {weekDays?.map(day => {
          return <button
            className={getWeekDaySelectorClass(day.index)}
            onClick={() => selectWeekday(day.index)}
          >
            {day.text.substr(0,2)}
          </button>
          })
        }
      </div>
    );
  }

  const isTimeAfter = (startTiming, endTiming) => moment(endTiming, 'hh:mm A') - moment(startTiming, 'hh:mm A') > 0;

  const setValidTime = () => {
    setIsInvalidStartTime(false);
    setIsInvalidEndTime(false);
  }

  const handleTimeChange = (currentStartTime, currentEndTime, setTime, isStartTime = true ) => {
    if (isStartTime) {
      if (currentEndTime === null || isTimeAfter(currentStartTime, currentEndTime)) {
        setValidTime();
      } else {
        setIsInvalidStartTime(true);
        setIsActive(true);
      }
      setTime(currentStartTime);
      return;
    }

    if (currentStartTime === null || isTimeAfter(currentStartTime, currentEndTime)) {
      setValidTime(true);
    }
    else {
      setIsInvalidEndTime(true);
    }
    setTime(currentEndTime);
  }

  const handleTimeslotModalClose = () => setShowTimeslotModal(false);

  const renderTimeInterval = () => {
    const startInputClasses = `${styles.startTime} ${isInvalidStartTime ? styles.timeInput : ''}`;
    const endInputClasses = `${styles.endTime} ${isInvalidEndTime ? styles.timeInput : ''}`;
    const timezone = slots?.[0]?.tz || null;

    const onCalculateTimeValueWhenFocused = (focused, time) => {
      if (!focused && time) return time;
      return undefined;
    }

    const onEndTimeChange = (endTimeString) => handleTimeChange(startTime, endTimeString, setEndTime, false);
    const onStartTimeChange = (startTimeString) => handleTimeChange(startTimeString, endTime, setStartTime);

    return (
      <div className={styles.timeIntervalInput}>
        <StatefulSearch
          showAllTimes
          input={
            <Input
              id="startTimeId"
              className={startInputClasses}
              labelPosition="right"
              placeholder={intl.formatMessage(locale.startTime)}
              error={isInvalidStartTime}
            />
          }
          onResultSelect={(e) => onStartTimeChange(e.title)}
          onCalculateValueWhenFocused={(focused) => onCalculateTimeValueWhenFocused(focused, startTime)}
          date={moment()}
          formatMessage={intl.formatMessage}
        />
        <StatefulSearch
          showAllTimes
          timesToSkip={["00:00"]}
          input={
            <Input
              id="endTimeId"
              tabindex="0"
              className={endInputClasses}
              label={timezone && moment()
                .tz(timezone)
                .format('z')}
              labelPosition="right"
              placeholder={intl.formatMessage(locale.endTime)}
              error={isInvalidEndTime}
              ref={searchRef}
            />
          }
          onResultSelect={(e) => onEndTimeChange(e.title)}
          onCalculateValueWhenFocused={(focused) => onCalculateTimeValueWhenFocused(focused, endTime)}
          date={moment()}
          formatMessage={intl.formatMessage}
        />
      </div>
    );
  }

  return (
    <Modal
      open={isOpen}
      onClose={handleTimeslotModalClose}
      size="large"
      className="applicableTimeslotModal"
      closeIcon
      closeOnDimmerClick={false}
    >
      <Modal.Header>
        {intl.formatMessage(locale.modalHeader)}
      </Modal.Header>

      <Modal.Content>
        <Form className={styles.timeslotModalForm}>
          <Form.Field required>
            <label htmlFor="dateRange" className={styles.dateRangeLabel}>
              {intl.formatMessage(locale.dateRange)}
            </label>
            {renderDateRange()}
          </Form.Field>
          <Form.Field>
            <label className={styles.dayRangeLabel}>
              {intl.formatMessage(locale.dayOfTheWeek)}
            </label>
            {renderWeekDaySelector()}
          </Form.Field>
          <Form.Field>
            <label className={`${styles.timeRangeLabel} ${isInvalidWeekday && styles.weekWarning}`}>
              {intl.formatMessage(locale.timeRange)}
            </label>  
            {renderTimeInterval()}
        </Form.Field>
        </Form>
        {isInvalidWeekday && <div className={styles.exclusiveWeekday}>
          <CrossIcon /><span>{intl.formatMessage(locale.weekdaysExclusive)}</span>
        </div>}
      </Modal.Content>

      <Modal.Actions className={styles.customTimeslotModalAction}>
        <Button onClick={handleTimeslotModalClose} className={styles.cancelBtn}>
          {intl.formatMessage(locale.modalCancel)}
        </Button>
        <Button primary disabled={isActive} onClick={() => handleTimeslotsSelected()} className={styles.selectBtn}>
          {intl.formatMessage(locale.selectTimeslot)}
        </Button>
     </Modal.Actions>
    </Modal>
  );
});

export default TimeslotModal;
